import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Plus } from 'lucide-react'
import filterIcon from '../../../assets/stock/TableMovementHeader/filter.svg'
import {
  LeftSide,
  RightSide,
  SubHeaderContainer,
  RefreshIcon,
  RefreshIconContainer,
  OptionsButton,
  ButtonCreate,
} from '../../../components/styles/subheader-style'
import refresh_act from '../../../assets/refresh-active.svg'
import { Content, SectionName } from './style'
import RegisterFamilyModal from './RegisterFamilyModal'

const FamiliesLayout: React.FC = () => {
  const location = useLocation()
  const [refresh, setRefresh] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const isInsideProductDevelopment = location.pathname.startsWith('/panel/families')

  useEffect(() => {
    const handleProductDevelopmentRefresh = (event: Event) => {
      const detail = (event as CustomEvent<{ tab?: string }>).detail
      if (detail?.tab === 'family') {
        setRefresh(previous => !previous)
      }
    }

    const handleProductDevelopmentCreate = (event: Event) => {
      const detail = (event as CustomEvent<{ tab?: string }>).detail
      if (detail?.tab === 'family') {
        setIsModalOpen(true)
      }
    }

    window.addEventListener('product-development-refresh', handleProductDevelopmentRefresh as EventListener)
    window.addEventListener('product-development-create', handleProductDevelopmentCreate as EventListener)

    return () => {
      window.removeEventListener('product-development-refresh', handleProductDevelopmentRefresh as EventListener)
      window.removeEventListener('product-development-create', handleProductDevelopmentCreate as EventListener)
    }
  }, [])

  return (
    <>
      {!isInsideProductDevelopment && (
        <SubHeaderContainer>
          <LeftSide>
            <SectionName>Famílias</SectionName>
          </LeftSide>

          <RightSide>
            <RefreshIconContainer onClick={() => setRefresh(prev => !prev)} title="Atualizar">
              <RefreshIcon src={refresh_act} alt="Atualizar" $spinning={isLoading} />
            </RefreshIconContainer>
            <OptionsButton onClick={() => {  }}>
              <img src={filterIcon} alt='Filtrar' style={{ width: '1.5rem', height: '1.5rem' }} />
            </OptionsButton>

            <ButtonCreate onClick={() => setIsModalOpen(true)}>
              <Plus size={18} />
              Nova família
            </ButtonCreate>
          </RightSide>
        </SubHeaderContainer>
      )}

      <Content>
        <Outlet context={{ refresh, isLoading, setIsLoading }} />
      </Content>

      {isModalOpen && (
        <RegisterFamilyModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            setRefresh(!refresh)
            setIsModalOpen(false)
          }}
        />
      )}
    </>
  )
}

export default FamiliesLayout